import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { pathOr } from "ramda";
import NoRecord from "../../../../../../../src/components/NoRecord/index";
import useStyles, { getMuiTheme } from "../../../DashletList/styles";
import { useTheme } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import { getCalculations } from '../../../../../../common/policyCalculation';
import MUIDataTable from "mui-datatables";

function CustomAccordionTable({data,setValue}) {
  const [responsive, setResponsive] = React.useState("standard");
  const [tableBodyHeight, setTableBodyHeight] = React.useState("100%");
  const [tableBodyMaxHeight, setTableBodyMaxHeight] = React.useState("");
  const classes = useStyles();
  const theme = useTheme();
  const tableHeaderData = pathOr({}, ['result', 'data', 'datalabels'], data);
  const tableBodyData = pathOr({}, ['result', 'data', 'data'], data);

  const redirectOnLink=(tab)=>{
    setValue(tab);
  }
  const makeid=()=> {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    
    return text;
  }
  // 03/02/2023 : Added as per AXA's request to add Digits upto 4 decimal places in Unit price parameter.
  const setValueBaseOnType = (type, rowData, key) =>{
    switch (type) {
      case 'decimal':
        if(key === "unitprice")
          return getCalculations('getUnitPriceInDecimal', rowData);
        else if(key === "totalunits")
          return getCalculations('getUnitPriceInDecimal', rowData);
        else 
          return getCalculations('getValueOnlyInDecimal', rowData);
        break;
      case 'return':
        return getCalculations('getValueOnlyInDecimalAndPercent', rowData);
      default:
        return rowData;
        break;
    }
  }

  const getFormattedParentData = [];
  const columns = [];
  let childData = [];
  tableBodyData.map((dataSet) => {
    dataSet.map(rowData => {
      if(rowData.type === 'Parent'){
        let eachParentRowData = rowData.data;
        let tempParentData = tableHeaderData.map((eachHeader) => {
          return eachParentRowData[eachHeader.key] !== undefined ? setValueBaseOnType(eachHeader.type, eachParentRowData[eachHeader.key], eachHeader.key) : null;
        });
        getFormattedParentData.push(tempParentData);
      }});
    let tempChildData = dataSet.filter(rowData => rowData.type === 'Child').map(data => data.type === 'Child' && data.data);
    childData.push(tempChildData);
  });

  tableHeaderData.map((header) =>{
    columns.push({'name': header.label});
  });


  const options = {
    responsive,
      tableBodyHeight,
      tableBodyMaxHeight,
      filter: false,
      download: false,
      serverSide: false,
      // count: parseInt(totalRecords),
      // rowsPerPage: rowsPerPage,
      // page,
      fixedHeader: true,
      fixedSelectColumn: false,
      search: false,
      print: false,
      viewColumns: false,
      selectableRowsHeader: false,
      // rowsPerPageOptions: [rowsPerPage],
      selectableRows: false,
      pagination:false,
      setRowProps: (row,rowKey) => { 
          return {
            style: { background: "#CCCCCC" }
          };
      },
      textLabels: {
        body: {
          noMatch: <NoRecord 
          view = 'dashlet_no_data' 
          subpanel_module=''
          module=''
        />,
  
        },
      },
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return (
        <React.Fragment>
          {childData[rowMeta.rowIndex].map((row) => (
            <TableRow key={makeid()}>
              <TableCell key={makeid()} ></TableCell>
              {tableHeaderData.map((header) =>{
                return <TableCell colSpan="1" className={classes.childDataCss} align="left" key={makeid()}>{setValueBaseOnType(header.type, row[header.key], header.key)}</TableCell>
              })}
            </TableRow>
          ))}
        </React.Fragment>
      );
    }
  };

return (
  <>
  <MuiThemeProvider theme={getMuiTheme(theme)}>

    <MUIDataTable
      data={getFormattedParentData}
      columns={columns}
      options={options}
      />
  </MuiThemeProvider>

  </>
  );
}

export default React.memo(CustomAccordionTable)